import { action } from "satcheljs";
import { INoteEntity } from "sh-models";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const notesModified = action(
    "NOTES_MODIFIED",
    (
        notesAdded: INoteEntity[],
        notesDeleted: INoteEntity[],
        notesUpdated: INoteEntity[],
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        notesAdded: notesAdded || [],
        notesDeleted: notesDeleted || [],
        notesUpdated: notesUpdated || [],
        viewState: viewState
    })
);

export default notesModified;
